export function slug(value: string): string {
  return encodeURIComponent(value)
}
